import { createFileRoute } from '@tanstack/react-router'
import { SuratTable } from '../../../../components/SuratTable'

export const Route = createFileRoute('/desa/$slug/dashboard/surat')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <SuratTable desaId={desaId} />
  },
})
